const FILENAME_UTF8_PREFIX = "filename*=UTF-8''"

export const resolveCsvFilename = (
  contentDisposition: string | undefined,
  fallbackFilename: string,
): string => {
  if (!contentDisposition) {
    return fallbackFilename
  }

  const utf8Start = contentDisposition.indexOf(FILENAME_UTF8_PREFIX)
  if (utf8Start >= 0) {
    const encodedName = contentDisposition
      .slice(utf8Start + FILENAME_UTF8_PREFIX.length)
      .split(';')[0]
      .trim()
    try {
      return decodeURIComponent(encodedName)
    } catch {
      return encodedName || fallbackFilename
    }
  }

  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  if (filenameMatch?.[1]) {
    return filenameMatch[1]
  }

  return fallbackFilename
}

export const downloadBlobAsFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
